import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_CONTACTS_REFRESH: createSagaAction('LEAD_CONTACTS_REFRESH'),
  GET_ALL_LEAD_CONTACTS: createSagaAction('GET_ALL_LEAD_CONTACTS'),
  ADD_LEAD_CONTACT: createSagaAction('ADD_LEAD_CONTACT'),
  REMOVE_LEAD_CONTACT: createSagaAction('REMOVE_LEAD_CONTACT'),

  CREATE_CONTACT: createSagaAction('CREATE_CONTACT'),
  LEAD_CONTACT_UPDATE: createSagaAction('LEAD_CONTACT_UPDATE'),
  LEAD_CONTACT_DELETE: createSagaAction('LEAD_CONTACT_DELETE'),

  UPDATE_LEAD_PRIMARY_CONTACT: createSagaAction('UPDATE_LEAD_PRIMARY_CONTACT')
}

// Action Creators
export const actions = {
  leadContactsRefresh: ({ leadId }) => ({
    type: constants.LEAD_CONTACTS_REFRESH.ACTION,
    leadId
  }),

  getAllLeadContacts: () => ({
    type: constants.GET_ALL_LEAD_CONTACTS.ACTION
  }),

  addLeadContact: ({ leadId, content, userId }) => ({
    type: constants.ADD_LEAD_CONTACT.ACTION,
    leadId,
    content,
    userId
  }),

  removeLeadContact: ({ contactId, leadId }) => ({
    type: constants.REMOVE_LEAD_CONTACT.ACTION,
    leadId,
    contactId
  }),

  createContact: ({ leadId, content, userId }) => ({
    type: constants.CREATE_CONTACT.ACTION,
    leadId,
    content,
    userId
  }),

  updateLeadContact: ({ leadId, attachmentId, userId, description, files }) => ({
    type: constants.LEAD_CONTACT_UPDATE.ACTION,
    leadId,
    attachmentId,
    userId,
    description,
    files
  }),

  deleteLeadContact: ({ attachmentId, leadId }) => ({
    type: constants.LEAD_CONTACT_DELETE.ACTION,
    leadId,
    attachmentId
  }),

  updateLeadPrimaryContact: ({ leadId, contactId }) => ({
    type: constants.UPDATE_LEAD_PRIMARY_CONTACT.ACTION,
    leadId,
    contactId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_CONTACTS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.LEAD_CONTACTS_REFRESH.SUCCESS:
      return {
        ...state,
        leadContacts: action.payload
      }
    case constants.GET_ALL_LEAD_CONTACTS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ALL_LEAD_CONTACTS.SUCCESS:
      return {
        ...state,
        allContacts: action.payload
      }
    case constants.LEAD_CONTACTS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.ADD_LEAD_CONTACT.SUCCESS:
      return {
        ...state
      }
    case constants.REMOVE_LEAD_CONTACT.SUCCESS:
      return {
        ...state
      }
    case constants.CREATE_CONTACT.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_CONTACT_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_CONTACT_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.UPDATE_LEAD_PRIMARY_CONTACT.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadContactActions.js